var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"},[_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t('list_view')))]),_vm._v(" "),_c('app-table',{attrs:{"id":"basic-list-view-table","options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }